import { Stores, User, VimeoUser } from "../types";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

export class UserStore {
  stores: Stores;

  users: User[] = [];

  vimeoUser: VimeoUser = {} as VimeoUser;

  isLoading = false;
  private _vimeoUserError = false;

  usersFilters: {
    [dataKey: string]: string | string[];
  } = {};

  constructor(stores: Stores) {
    this.stores = stores;

    makeAutoObservable(this);
  }

  get vimeoUserError() {
    return this._vimeoUserError;
  }

  set vimeoUserError(vimeoUserError) {
    this._vimeoUserError = vimeoUserError;
  }

  getUsers = async () => {
    this.isLoading = true;
    try {
      let users = await api.getUsers();
      this.users = users;
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addUser = async (data: Partial<User>) => {
    this.isLoading = true;
    try {
      // let categories = await api.addUser();
      // this.categories.unshift(categories);
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  updateUser = async (data: Partial<User>) => {
    this.isLoading = true;
    try {
      // let categories = await api.updateUser();
      // this.categories = this.categories.map((category) =>
      //   article.id === article.id ? article : null
      // );
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  deleteUser = async (data: Partial<User>) => {
    this.isLoading = true;
    try {
      // let categories = await api.deleteUser();
      // this.categories = this.categories.filter((category) => "");
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  fetchVimeoUser = async () => {
    this.isLoading = true;
    try {
      const vimeoUser = await api.getVimeoUser();

      if (!vimeoUser) throw new Error("Vimeo Error");

      this.vimeoUser = vimeoUser;
    } catch (err) {
      this.vimeoUserError = true;
    } finally {
      this.isLoading = false;
    }
  };
}
